module.exports = __webpack_public_path__ + "img/zoom.ab899a7b.png";